<template>
  <!--
    Gestión de certificaciones para el resto de clientes (no solaring): únicamente
    certificación civil, sin tabs.
  -->
  <div>
    <certificacion-civil />
  </div>
</template>

<script>
import certificacionCivil from '·/components/certifications/certificacion-civil'

export default {
  name: 'CertificationManage',
  components: {
    certificacionCivil,
  },
}
</script>

<style scoped>
</style>
